export default __webpack_public_path__ + "static/media/other2.968adbf6.jpg";